// https://vuex.vuejs.org/en/actions.html

export default {
    setLanguageCurrent({ commit }, payload) {
        commit('SET_LANGUAGE_CURRENT', payload);
    },
    setChecked({ commit }, payload) {
        commit('SET_CHECKED', payload);
    },
    setUser({ commit }, payload) {
        commit('SET_USER', payload);
    },
    setCourse({ commit }, payload) {
        commit('SET_COURSE', payload);
    },
    setHost({ commit }, payload) {
        commit('SET_HOST', payload);
    },
    setSecApiUrl({ commit }, payload) {
        commit('SET_SEC_API_URL', payload);
    },
    setNewOrder({ commit }, payload) {
        commit('SET_newOrder', payload);
    },
    openModal({ commit }, payload) {
        commit('OPEN_MODAL', payload);
    },
    selectValue({ commit }, payload) {
        commit('SET_VALUE', payload);
    },
    setLastUpdate({ commit }, payload) {
        commit('SET_LAST_UPDATE', payload);
    },
    setLanguages({ commit }, payload) {
        commit('SET_LANGUAGES', payload);
    },
    setRoles({ commit }, payload) {
        commit('SET_ROLES', payload);
    },
    setStats({ commit }, payload) {
        commit('SET_STATS', payload);
    },
    setLanguage({ commit }, payload) {
        commit('SET_LANGUAGE', payload);
    },
    setText({ commit }, payload) {
        commit('SET_TEXT', payload);
    },
    setLocations({ commit }, payload) {
        commit('SET_LOCATION', payload);
    },
    setMessage({ commit }, payload) {
        commit("SET_MESSAGE", payload);
      },
    setRoles({ commit }, payload) {
        commit('SET_ROLE', payload);
    },
    setRoutes({ commit }, payload) {
        commit('SET_ROUTES', payload);
    },
    setBusiness({ commit }, payload) {
        commit('SET_BUSINESS', payload);
    },
    setSchedule({ commit }, payload) {
        commit('SET_SCHEDULE', payload);
    },
    setRoot({ commit }, payload) {
        commit('SET_ROOT', payload);
    }
}
